import { getAssetsBase } from './assets-base.js';

export function initGlossary($) {
  console.log('initGlossary is running');
  const glossaryContainer = $('#glossary-container');
  const searchInput = $('#glossary-search');
  const dataUrl = `${getAssetsBase()}data/glossary.json`;
  const itemsPerPage = 20;
  let glossaryData = [];
  let currentPage = 1;
  let focusFirstHeading = false; // NEW: flag for pagination focus

  function renderGlossary(items) {
    glossaryContainer.empty();
    const start = (currentPage - 1) * itemsPerPage;
    const paginatedItems = items.slice(start, start + itemsPerPage);
  
    console.log('renderGlossary called. Current page:', currentPage);
    paginatedItems.forEach(item => {
      const html = `
        <div class="glossary-entry">
          <h3 class="fw-bold">${item.term}</h3>
          <div class="glossary-definition">
            ${item.definition
              .split('\n')
              .map(line => `<p class="mb-0">${line.trim()}</p>`)
              .join('')}
          </div>
        </div>
      `;
      glossaryContainer.append(html);
    });
  
    renderPagination(items.length);
  
    // Focus the first glossary term heading ONLY if triggered by pagination
    if (focusFirstHeading) {
      setTimeout(() => {
        const firstHeading = glossaryContainer.find('.glossary-entry h3').first();
        if (firstHeading.length) {
          firstHeading.attr({
            tabindex: '-1',
            role: 'heading',
            'aria-level': '3'
          }).focus();
          console.log('Focused glossary term:', firstHeading.text().trim());
        } else {
          console.log('No glossary term found to focus.');
        }
        focusFirstHeading = false; // reset flag
      }, 0);
    }
  }
  

  function renderPagination(totalItems) {
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    const paginations = $('.glossary-pagination'); // top and bottom
    paginations.empty();
  
    // Helper to append buttons to both top and bottom
    function appendToPaginations(btn) {
      paginations.each(function () {
        $(this).append(btn.clone(true)); // true = copy events
      });
    }
  
    // Previous button
    const prevBtn = $('<button type="button" class="btn btn-pagination prev chaseanalytics-track-link" aria-label="Go to previous glossary page" data-pt-name="btn_previous">Previous</button>');
    if (currentPage === 1) {
      prevBtn.prop('disabled', true);
    } else {
      prevBtn.on('click', function () {
        currentPage--;
        focusFirstHeading = true;
        renderGlossary(filterGlossary(searchInput.val()));
      });
    }
    appendToPaginations(prevBtn);
  
    // Page number buttons
    for (let i = 1; i <= totalPages; i++) {
      const isActive = i === currentPage;
      const btn = $(
        `<button type="button" class="btn btn-pagination chaseanalytics-track-link ${isActive ? 'active' : ''}"${
          isActive ? ' aria-current="page"' : ''
        } aria-label="Page ${i} of ${totalPages}" data-pt-name="btn_page_${i}">${i}</button>`
      );
      btn.on('click', () => {
        currentPage = i;
        focusFirstHeading = true;
        renderGlossary(filterGlossary(searchInput.val()));
      });
      appendToPaginations(btn);
    }
  
    // Next button
    const nextBtn = $('<button type="button" class="btn btn-pagination next chaseanalytics-track-link" aria-label="Go to next glossary page" data-pt-name="btn_next">Next</button>');
    if (currentPage === totalPages || totalPages === 0) {
      nextBtn.prop('disabled', true);
    } else {
      nextBtn.on('click', function () {
        currentPage++;
        focusFirstHeading = true;
        renderGlossary(filterGlossary(searchInput.val()));
      });
    }
    appendToPaginations(nextBtn);
  }
  
  

  function filterGlossary(query) {
    if (!query) return glossaryData;
    return glossaryData.filter(item =>
      item.term.toLowerCase().includes(query.toLowerCase())
    );
  }

  // Load the glossary data
  $.getJSON(dataUrl, function (data) {
    glossaryData = data;
    renderGlossary(glossaryData);
  });

  // Input search does NOT trigger focus
  searchInput.on('input', function () {
    currentPage = 1;
    const filtered = filterGlossary($(this).val());
    renderGlossary(filtered);
  });
}
